/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Faq_Affiliation_QInputs */

const en_gc_resources_faq_affiliation_q = /** @type {(inputs: Gc_Resources_Faq_Affiliation_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this the official GridCraft website?`)
};

const zh_gc_resources_faq_affiliation_q = /** @type {(inputs: Gc_Resources_Faq_Affiliation_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是 GridCraft 官方网站吗？`)
};

/**
* | output |
* | --- |
* | "Is this the official GridCraft website?" |
*
* @param {Gc_Resources_Faq_Affiliation_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_faq_affiliation_q = /** @type {((inputs?: Gc_Resources_Faq_Affiliation_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Faq_Affiliation_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_faq_affiliation_q(inputs)
	return zh_gc_resources_faq_affiliation_q(inputs)
});
export { gc_resources_faq_affiliation_q as "gc.resources.faq.affiliation.q" }